import axiosInstance from './AxiosInstance';

export function getReversals(page = 1) {
    return axiosInstance.get('ledger/reversals', { params: { page } });
}

export function getReversal(id) {
    return axiosInstance.get(`ledger/reversals/${id}`);
}

export function initiateReversal(data) {
    return axiosInstance.post('ledger/reversals', data);
}

export function getReconciliationRequiredReversals(page = 1) {
    return axiosInstance.get('ledger/reversals/reconciliation-required', { params: { page } });
}

export function reconcileReversal(reversalId, data) {
    return axiosInstance.post(`ledger/reversals/${reversalId}/reconcile`, data);
}

export function getVendorInitiatedReversals(page = 1) {
    return axiosInstance.get('ledger/vendor-initiated-reversals', { params: { page } });
}

export function getVendorInitiatedReversal(uuid) {
    return axiosInstance.get(`ledger/vendor-initiated-reversals/${uuid}`);
}

export function createVendorInitiatedReversal(data) {
    return axiosInstance.post('ledger/vendor-initiated-reversals', data);
}

export function lookupOutboundPayout(receipt) {
    return axiosInstance.get('ledger/vendor-initiated-reversals/lookup-outbound', { params: { receipt } });
}
